import { useLocalStorage } from "@reactuses/core";
import { useAppSelector } from "../../../redux/hooks";

/**
 * Tracks whether the user has dismissed the first-run takeover, persisted per
 * org + channel so it only shows once. Mirrors DismissibleBanner's storage approach.
 */
export const useFirstRunEntered = () => {
  const orgId = useAppSelector((state) => state.user.organization_id);
  const channel = useAppSelector((state) => state.channel.currentChannel);
  const [entered, setEntered] = useLocalStorage<boolean>(`workflow-progress-v2:entered:${orgId}:${channel}`, false);

  return { entered: !!entered, markEntered: () => setEntered(true) };
};
